/**
 * Main application component
 *
 * features:
 * - router provider for react-router
 * - router for app routes
 */

import { router } from '@/app/routes/AppRoutes';
import { RouterProvider } from 'react-router';
import { SupportRequestSheet } from '@/features/support-request';
import { setSupportSheetOpen, useIsSupportSheetOpen } from '@/widgets/app-shell';

function App() {
  const isSupportSheetOpen = useIsSupportSheetOpen();

  return (
    <>
      <RouterProvider router={router} />
      <SupportRequestSheet open={isSupportSheetOpen} onOpenChange={setSupportSheetOpen} />
    </>
  );
}

export default App;
